import { Card, Grid, Typography, useTheme } from '@material-ui/core';
import { DocumentoResponse } from 'api/Associado/documentos';
import AssembleiaDateTime from 'components/AssembleiaDateTime';
import AssembleiaPautas from 'components/AssembleiaPautas/AssembleiaPautas';
import Breadcrumb from 'components/BreadCrumb/BreadCrumb';
import { IBreadCrumbItem } from 'components/BreadCrumb/BreadCrumbItem';
import DuvidasFrequentes from 'components/DuvidasFrequentes';
import { AlertIcon, ColaboradorIcon, MaletaIcon, SyncIcon } from 'components/Icons';
import InfoCard from 'components/LabelValueCard/LabelValueCard';
import LayoutContext from 'components/Layout/LayoutContext';
import PageSubtitle from 'components/PageSubtitle/PageSubtitle';
import PageTitle from 'components/PageTitle/PageTitle';
import Player from 'components/Player/Player';
import PrivateContainer from 'components/PrivateContainer';
import SeletorContasParaVotoModal, { ISeletorContasParaVotoGenericProps } from 'components/SeletorContasParaVotoModal/SeletorContasParaVotoModal';
import { parseISO } from 'date-fns';
import { AssembleiaStatus } from 'enuns/AssembleiaStatus';
import { RestricaoConta } from 'enuns/RestricaoConta';
import { MainRoutePath } from 'library/Routes';
import DocumentosModalForm, { EditarDocumentosModalProps } from 'pages/Associado/AssembleiaAssociado/DocumentoModal';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { assembleiasAssociadoActionsLoadPautas, assembleiasAssociadoListDocumentos } from 'store/modules/AssembleiasAssociadoActions';
import { modalsActionsOpen } from 'store/modules/ModalsActions';
import { IReducer } from 'store/Reducer';
import { getPermitirVoto, getTotalContasSelecionadasPeloUsuario } from 'utils/AssembleiaUtils';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';
import { getUniqueKey } from 'utils/KeyUtils';
import { isAValidVideoUrl } from 'utils/PlayerUtils';
import styles from './AssembleiaAssociadoLive.scss';
import useStyle from './style';

const rootClassName = styles.rootClassName;

export default () => {
  const { t } = useTranslation();
  const { currentEvent, loadingPautas } = useSelector((state: IReducer) => state.assembleias);
  const { usuario } = useSelector((state: IReducer) => state.auth);
  const classes = useStyle();
  const theme = useTheme();
  const dispatchActions = useDispatch();
  const [listaDocumentos, setListaDocumentos] = useState<DocumentoResponse[]>([]);
  const {isMobile} = useContext(LayoutContext);

  const buscarDocumentos = useCallback(() => {
    if(currentEvent){
      dispatchActions(
        assembleiasAssociadoListDocumentos(
          currentEvent.idAssembleia,
          documentos => {
            setListaDocumentos(documentos);
          },
          error => {
            AxiosErrorHandler(error);
          }
        )
      );
    }
  },[dispatchActions, currentEvent]);

  const breadCrumb = useMemo<IBreadCrumbItem[]>(
    () => [
      {
        nome: t('MainRoute.title'),
        url: MainRoutePath,
      },
      {
        nome: currentEvent!.titulo,
      },
    ],
    [t, currentEvent]
  );

  // const contadorContasHasPermission = useCallback((): boolean => {
  //   return usuario!.perfil.associadoRoute.assembleias.pautas.participar;
  // }, [usuario])

  // const contadorContasDisabled = useCallback((): boolean => {
  //   if (currentEvent) {
  //     if (!contadorContasHasPermission()) {
  //       return true
  //     }
  //     if (currentEvent.contasDisponiveis && usuario && currentEvent.status === AssembleiaStatus.Live) {
  //       return currentEvent.contasDisponiveis.length === 0 ? true : false;
  //     }
  //   }
  //   return true;
  // }, [currentEvent, usuario, contadorContasHasPermission])

  // const getContadorContas = (): string | undefined => {
  //   if (currentEvent && currentEvent.contasDisponiveis && usuario) {
  //     return getTotalContasSelecionadasPeloUsuario(currentEvent.contasDisponiveis, usuario.cpfCnpj) + '/' + getTotalContasSelecionadasOuNaoPeloUsuario(currentEvent.contasDisponiveis, usuario.cpfCnpj);
  //   }
  //   return undefined;
  // }

  // const openConfiguracaoVotos = () => {
  //   const modalKey: string = getUniqueKey();
  //   dispatchActions(
  //     modalsActionsOpen(
  //       SeletorContasParaVotoModal,
  //       {
  //         genericProps: {
  //           cpfCnpj: usuario!.cpfCnpj,
  //           assembleia: currentEvent!,
  //           key: modalKey
  //         } as ISeletorContasParaVotoGenericProps
  //       },
  //       modalKey
  //     )
  //   );
  // }

  const getUrlTransmissao = useCallback((): string | null => {
    if (currentEvent?.urlTransmissao) {
      return currentEvent.urlTransmissao;
    }
    return null;
  }, [currentEvent])

  const hasPermissionToShowPautas = useCallback(():boolean => {
    if (
      usuario!.perfil.associadoRoute.assembleias.pautas.ver ||
      usuario!.perfil.associadoRoute.assembleias.pautas.participar
    ) {
      return true;
    }
    return false;
  }, [usuario])

  const transmissaoHasPermission = (): boolean => {
    return usuario!.perfil.associadoRoute.assembleias.live.video.ver ||
      usuario!.perfil.associadoRoute.assembleias.live.video.participar;
  }

  const getDuvidas = useCallback(() => {
    if (
      currentEvent && 
      (
        usuario!.perfil.associadoRoute.assembleias.live.duvidasSugestoes.ver ||
        usuario!.perfil.associadoRoute.assembleias.live.duvidasSugestoes.participar
      )
    ) {
      return (
        <Grid item xs={12} sm={12} md={12} >
          <DuvidasFrequentes
            associado={usuario!}
            evento={currentEvent}
          />
        </Grid>
      )
    }
  }, [currentEvent, usuario])

  const getSubtitle = useCallback(() => {
    switch(currentEvent!.status) {
      case AssembleiaStatus.Live:
        return t('AssembleiaAssociadoRoute.subtitleLive');
      case AssembleiaStatus.Pos:
        return t('AssembleiaAssociadoRoute.subtitlePos');
      case AssembleiaStatus.Encerrado:
        return t('AssembleiaAssociadoRoute.subtitleEncerrado');
      default:
        return '';
    }
  }, [currentEvent, t])

  const encerradoESemPresenca = useCallback((): boolean => {
    if (currentEvent && usuario) {
      return getTotalContasSelecionadasPeloUsuario(currentEvent!.contasDisponiveis || [], usuario!.cpfCnpj) === 0 && currentEvent!.status === AssembleiaStatus.Encerrado ? true : false;
    }
    return false;
  }, [currentEvent, usuario])


  const openDocumentos = useCallback(() => {
    if (!listaDocumentos || !currentEvent) return;
    const modalKey: string = getUniqueKey();
    dispatchActions(
      modalsActionsOpen(
        DocumentosModalForm,
        {
          genericProps: {
            key: modalKey,
            idAssembleia: currentEvent.idAssembleia,
            listaDocumentos: listaDocumentos
          },
        } as EditarDocumentosModalProps,
        modalKey
      )
    );
  }, [dispatchActions, currentEvent, listaDocumentos]);

  const totalContas = useMemo<number>(() => {
    return currentEvent?.contasDisponiveis?.length || 0;
  }, [currentEvent])

  const totalPresentes = useMemo<number>(() => {
    return currentEvent?.contasDisponiveis?.filter(it => it.presente).length || 0;
  }, [currentEvent])

  const presentes = useMemo<string>(() => {
    return `${totalPresentes}/${totalContas}`;
  }, [totalContas, totalPresentes])

  const abrirSelecaoContas = useCallback(() => {
    const modalKey: string = getUniqueKey();
    dispatchActions(
      modalsActionsOpen(
        SeletorContasParaVotoModal,
        {
          genericProps: {
            cpfCnpj: usuario?.cpfCnpj,
            assembleia: currentEvent,
            key: modalKey,
          } as ISeletorContasParaVotoGenericProps,
        },
        modalKey
      )
    );
  }, [dispatchActions, usuario, currentEvent])

  useEffect(() => {
    buscarDocumentos();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {
    if (currentEvent && usuario!.cpfCnpj && currentEvent.needLoadPautas) {
      dispatchActions(
        assembleiasAssociadoActionsLoadPautas(currentEvent.idAssembleia)
      );
    }
  }, [currentEvent, usuario, dispatchActions]);

  const seletorContasDisabled = useMemo<boolean>(() => {
    return (
      currentEvent?.status !== AssembleiaStatus.Live ||
      totalContas <= 0
    )
  }, [totalContas, currentEvent])

  return (
    <PrivateContainer contentClassName={classes.content} >
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <PageTitle title={currentEvent!.titulo} />
          <Breadcrumb itens={breadCrumb} />
        </Grid>
        <Grid item xs={12} md={7} >
          <Grid container className={[classes.spaceTop, classes.spaceBotton].join(' ')} >
            <Grid item xs={12} md={2}>
              <PageSubtitle subtitle={getSubtitle()} />
            </Grid>
            <Grid item xs={12} md={10} >
              {currentEvent?.dataEvento && (
                <AssembleiaDateTime date={parseISO(currentEvent.dataEvento)} dateFim={parseISO(currentEvent.dataEventoFim)} />
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} className={[classes.topContent, classes.topContentWithPlayer].join(' ')} >
            { transmissaoHasPermission() && isAValidVideoUrl(getUrlTransmissao() || '') ? (
              <Grid item xs={12}>
                <Player url={ getUrlTransmissao() || '' }  />
              </Grid>
            ) : null }
              <Grid item xs={12} >
                <div className={classes.containerInfoCard}>
                  <Grid  className={classes.infoCard}>
                    <InfoCard
                      label={t('AssembleiaAssociado.visualizadorPresenca')}
                      value={presentes}
                      button={!seletorContasDisabled}
                      onClick={!seletorContasDisabled ? () => abrirSelecaoContas() : undefined}
                    />
                  </Grid>
                  <Grid   className={classes.infoCard}>
                    <InfoCard
                      label={t('AssembleiaAssociado.visualizadorDocumentos')}
                      value={listaDocumentos !== [] ? listaDocumentos.length : 0}
                      button
                      onClick={() => openDocumentos()}
                    />
                  </Grid>
                </div>
              </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={5}>
        {
          getDuvidas()
        }
        </Grid>
        {totalPresentes > 0 && currentEvent!.status === AssembleiaStatus.Live && !getPermitirVoto(currentEvent!.contasDisponiveis || [], usuario!.cpfCnpj) && (
          <Grid item xs={12} className={[classes.topContent, classes.topContentWithPlayer].join(' ')}>
            <Grid component={Card} container>
              <Grid item xs={12} alignItems="center" justify="center" style={{ display: 'flex' }}>
                { currentEvent!.contasDisponiveis?.find(it => it.restricao === RestricaoConta.Colaborador) && (<ColaboradorIcon color={theme.palette.primary.main} className={classes.iconeRestricao} />) }
                { currentEvent!.contasDisponiveis?.find(it => it.restricao === RestricaoConta.ColaboradorPJ || it.restricao === RestricaoConta.ColaboradorMei) && (<MaletaIcon color={theme.palette.primary.main} className={classes.iconeRestricao} />) }
                {!isMobile && (
                  <Typography color="textPrimary" variant="body1">
                    {t('SeletorContasParaVotoModal.textos.unicaContaColaborador')}
                  </Typography>
                )}
              </Grid>
              {isMobile && (
                <Grid item xs={12}>
                  <Typography color="textPrimary" variant="body1">
                    {t('SeletorContasParaVotoModal.textos.unicaContaColaborador')}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {
          hasPermissionToShowPautas() && currentEvent!.pautas && currentEvent!.pautas.length > 0 ? (
            <Grid item xs={12} sm={12} className={ rootClassName + '-grid-item' }>
              <AssembleiaPautas totalContas={totalContas} totalPresentes={totalPresentes} pautas={ currentEvent!.pautas } /> 
            </Grid>
          ) : (
            <Grid item xs={12} className={ rootClassName + '-grid-item' }>
              <Card>
                <div className={ rootClassName + '-pautas-warning' }>
                  {
                    encerradoESemPresenca() ? (
                      <>
                        <AlertIcon className={ rootClassName + '-pauta-alert-icon' } />
                        <Typography className={ rootClassName + '-pauta-alert-message' } dangerouslySetInnerHTML={{ __html: t('AssembleiaAssociadoRoute.pautas.ended') }} />
                      </>
                    ) :
                      loadingPautas ? (
                        <>
                          <SyncIcon className={ rootClassName + '-pauta-loading-icon animation-rotate' } />
                          <Typography className={ rootClassName + '-pauta-alert-message' }>
                            { t('AssembleiaAssociadoRoute.pautas.loading') }
                          </Typography>
                        </>
                      ) : (
                        <>
                          <AlertIcon className={ rootClassName + '-pauta-alert-icon' } />
                          <Typography className={ rootClassName + '-pauta-alert-message' }>
                            { t('AssembleiaAssociadoRoute.pautas.notFound') }
                          </Typography>
                        </>
                      )
                  }
                </div>
              </Card>
            </Grid>
          )
        }
      </Grid>
    </PrivateContainer>
  );
}